import { render, staticRenderFns } from "./StarterPage.vue?vue&type=template&id=1665ef54"
import script from "./StarterPage.vue?vue&type=script&lang=js"
export * from "./StarterPage.vue?vue&type=script&lang=js"
import style0 from "./StarterPage.vue?vue&type=style&index=0&id=1665ef54&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports